import React from 'react';
import { Route } from 'react-router-dom';
import SuperTokens from 'supertokens-auth-react';
import Dashboard from './modules/Dashboard/Dashboard';
import CreatePassword from './modules/OutsidePages/CreatePassword/CreatePassword';
import Logout from './modules/Logout/Logout';
import Profile from './modules/Admins/Profile/Profile';
import ForgotPassword from './modules/OutsidePages/ForgotPassword/ForgotPassword';
import ResetPassword from './modules/OutsidePages/ResetPassword/ResetPassword';

// Wrapper component for SuperTokens to avoid calling getRoutingComponent at module load
const SuperTokensRoutes = () => {
  return SuperTokens.getRoutingComponent();
};

// Routes that should use the admin layout
export const layoutRoutes = [
  <Route key="dashboard" path="/dashboard" element={<Dashboard />} />,
  <Route key="profile" path="/profile" element={<Profile />} />,
];

// Routes that should NOT use the admin layout (noLayout)
export const noLayoutRoutes = [
  <Route key="invitation" path="/invitation" element={<CreatePassword />} />,
  <Route key="forgot" path="/forgot" element={<ForgotPassword />} />,
  <Route key="reset" path="/reset" element={<ResetPassword />} />,
  <Route key="logout" path="/logout" element={<Logout />} />,
  <Route key="auth" path="/auth" element={<SuperTokensRoutes />} />,
];
